import React, { FunctionComponent } from 'react'
import { Radio } from '@afterpaytouch/core'
import { Country } from '@afterpay/types'
import { useCountry } from '../../state'
import { useTranslation } from '../../utils/convergence'
import { Weekday } from '../../model'

interface InlinePaymentDayListProps {
  onChange: (day: Weekday) => void
  selectedDay: Weekday
}

const getTranslatedWeekdayLabel = (t: (key: string) => string, day: Weekday): string => {
  switch (day) {
    case 0:
      return t('common:preferredDay.weekday.0')
    case 1:
      return t('common:preferredDay.weekday.1')
    case 2:
      return t('common:preferredDay.weekday.2')
    case 3:
      return t('common:preferredDay.weekday.3')
    case 4:
      return t('common:preferredDay.weekday.4')
    case 5:
      return t('common:preferredDay.weekday.5')
    case 6:
      return t('common:preferredDay.weekday.6')
    default:
      return ''
  }
}

export const InlinePaymentDayList: FunctionComponent<InlinePaymentDayListProps> = ({ onChange, selectedDay }) => {
  const { t } = useTranslation()
  const countryCode = useCountry()
  const days: Weekday[] = countryCode === Country.CA || countryCode === Country.US ? [0, 1, 2, 3, 4, 5, 6] : [1, 2, 3, 4, 5, 6, 0]

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    onChange(parseInt(e.target.value) as Weekday)
  }

  return (
    <Radio.Group name='inline-payment-days' value={`${selectedDay}`} onChange={handleChange} kind='Option' indent>
      {days.map((day: Weekday) => (
        <Radio.Button
          key={`inline-payment-day-${day}`}
          label={getTranslatedWeekdayLabel(t, day)}
          value={`${day}`}
          labelWidth='Full'
          labelPlacement='Top'
          roundedBorder
          testNameSpace={`inline-payment-day-${day}`}
        />
      ))}
    </Radio.Group>
  )
}
